"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Mark {
    constructor(type) {
        this.type = type;
    }
    toJSON() {
        return {
            type: this.type
        };
    }
}
exports.Mark = Mark;
//# sourceMappingURL=mark.js.map